export type MonthlyExpenseCategory = 'labor' | 'rent' | 'utilities' | 'marketing' | 'other';

export const EXPENSE_CATEGORIES: MonthlyExpenseCategory[] = [
  'labor',
  'rent',
  'utilities',
  'marketing',
  'other',
];

export const EXPENSE_LABELS: Record<MonthlyExpenseCategory, string> = {
  labor: 'Labor / salaries',
  rent: 'Rent',
  utilities: 'Utilities',
  marketing: 'Marketing',
  other: 'Other fixed',
};

export type MenuQuadrant = 'star' | 'workhorse' | 'puzzle' | 'dog';

export function menuQuadrant(popularityPct: number, marginPct: number): MenuQuadrant {
  const highPop = popularityPct >= 50;
  const highMargin = marginPct >= 50;
  if (highPop && highMargin) return 'star';
  if (highPop && !highMargin) return 'workhorse';
  if (!highPop && highMargin) return 'puzzle';
  return 'dog';
}

export const QUADRANT_LABELS: Record<MenuQuadrant, string> = {
  star: 'Star',
  workhorse: 'Workhorse',
  puzzle: 'Puzzle',
  dog: 'Dog',
};

export const QUADRANT_HINTS: Record<MenuQuadrant, string> = {
  star: 'Keep promoting — high volume and strong margin.',
  workhorse: 'Popular but thin margin — consider a small price increase.',
  puzzle: 'Good margin but low sales — promote or reposition.',
  dog: 'Low volume and low margin — consider removing.',
};

export function monthStart(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}-01`;
}

export function monthEndIso(monthYmd: string): string {
  const [y, m] = monthYmd.split('-').map(Number);
  const end = new Date(y!, m!, 0);
  end.setHours(23, 59, 59, 999);
  return end.toISOString();
}

export function monthStartIso(monthYmd: string): string {
  return new Date(monthYmd).toISOString();
}

export function pct(n: number, d: number): number {
  return d > 0 ? Math.round((n / d) * 1000) / 10 : 0;
}

/** Matches cash_drops.business_day and SQL `(ts at time zone 'Asia/Yerevan')::date`. */
export const BUSINESS_TIMEZONE = 'Asia/Yerevan';

export function toBusinessDay(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function toBusinessDayYerevan(iso: string): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: BUSINESS_TIMEZONE }).format(new Date(iso));
}

export function businessDayRangeIso(fromYmd: string, toYmd: string): { fromIso: string; toIso: string } {
  return {
    fromIso: `${fromYmd}T00:00:00+04:00`,
    toIso: `${toYmd}T23:59:59.999+04:00`,
  };
}
